import { render, staticRenderFns } from "./NewsInfoView.vue?vue&type=template&id=b90f09d0&scoped=true&"
import script from "./NewsInfoView.vue?vue&type=script&lang=js&"
export * from "./NewsInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90f09d0",
  null
  
)

export default component.exports